(function () {
    'use strict';

    var module = angular.module('uwAgenda.ringfoon');
    module.controller('NewCallModalController', ['CallsService', '$uibModalInstance', NewCallModalControllerFn]);

    /* controller for displaying New-Call-Information */
    function NewCallModalControllerFn(CallsService, $uibModalInstance) {
        /* jshint validthis:true */
        var vm = this;

        vm.incomingCall = CallsService.incomingCall;
        vm.users = CallsService.incomingCall.doctors;  
        
        vm.selectedUser = CallsService.incomingCall.selectedDoctor;
        
        // // anser the call
        // vm.answer = function () {
        //     // close modal if NO user available (ShowUserOnIncomingCall)
        //     if (vm.call.with.data.user && vm.call.with.data.user.length <= 0) {
        //         CallsService.closeModal();
        //     }

        //     CallsService.answer(); // send to ivr to answer the call
        // };    
        
        vm.select = function(user) {

            CallsService.incomingCall.doctors.forEach(function(doctor) {
                doctor.selected = false;
            });

            // set selected doctor in CallsService
            CallsService.incomingCall.selectedDoctor = user;

            $uibModalInstance.close();
        };
        
        // vm.answer = function() {
        //     $uibModalInstance.close();
        // }

        vm.close = function () {
            $uibModalInstance.dismiss();
        };
    }
})();
